import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { listGender } from "data/list";
import { formatPhoneNumber } from "helper/format-phone";
import React from "react";
import moment from "moment";
import { ColumnsEdit } from "types/models/column-table-edit";
import {
  birthday2Age,
  convertDateStringToDateTimezone_7Dayjs,
  convertIosStringToDateDayjs,
  formatDateToString,
  formatDateToStringTimezone_7,
} from "helper/common";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import dayjs from "dayjs";
const { INPUT, DATE_DAY_INPUT, COMBO_BOX, NUMBER, DATE_DISABLE, DATE } =
  FIELD_TYPE;

const fields = () => {
  const fields: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      name: "maBenhNhan",
      expand: false,
    },
    {
      type: INPUT,
      label: "Tên bệnh nhân",
      name: "hoTen",
      expand: false,
    },
    {
      type: DATE,
      label: "Ngày sinh",
      name: "ngaySinh",
      expand: false,
    },
    {
      type: COMBO_BOX,
      label: "Nguồn bệnh nhân",
      name: "nguonBenhNhan",
      options: JSON.parse(localStorage.getItem("nguonBN")),
      expand: false,
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      name: "dienThoai",
      expand: false,
    },

    {
      type: COMBO_BOX,
      label: "Giới tính",
      name: "gioiTinh",
      expand: true,
      options: listGender,
    },
    {
      type: NUMBER,
      label: "Số thẻ BHYT",
      name: "maTheBhyt",
      expand: true,
    },

    {
      type: INPUT,
      label: "BS chỉ định",
      name: "bacSiChiDinh",
      expand: true,
    },
    {
      type: COMBO_BOX,
      label: "Loại KCB",
      placeholder: "Chọn",
      name: "loaiKcb",
      expand: true,
      options: JSON.parse(localStorage.getItem("loaiKCB")),
    },
    {
      type: DATE_DAY_INPUT,
      label: "Thời gian từ",
      name: "ngayHenPTTu",
      expand: false,
      disableDate: false,
    },
    {
      type: DATE_DAY_INPUT,
      label: "Thời gian đến",
      name: "ngayHenPTDen",
      expand: false,
      disableDate: false,
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái CSKH",
      name: "trangThaiCSKH",
      expand: true,
      options: JSON.parse(localStorage.getItem("TTCSKH")),
    },

    {
      type: COMBO_BOX,
      label: "Khu KCB",
      placeholder: "Chọn",
      name: "khuKCB",
      expand: true,
      options: JSON.parse(localStorage.getItem("khuKham")),
    },
  ];
  return fields;
};

const apoitmentColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    width: 50,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    align: "center",
    width: 70,
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    show: true,
    align: "left",
    width: 150,
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    show: true,
    width: 150,
    align: "right",
    render: (v) => formatPhoneNumber(v),
  },
  {
    title: "Chỉ định",
    dataIndex: "chiDinhNgoaiTru",
    show: true,
    width: 500,
    align: "left",
  },
  {
    title: "TG chỉ định",
    dataIndex: "tgChiDinhNgoaiTru",
    key: "thoiGian",
    show: true,
    align: "center",
    width: 150,
    render: (v) => (v ? moment(v).format(FORMAT_TIME.dateTime) : ""),
  },
  {
    title: "Ghi chú",
    dataIndex: "ghiChuPT",
    key: "ghiChuPT",
    show: true,
    align: "left",
    width: 100,
    // render: (text, record) =>
    //   text ? moment(text).format("HH:mm DD/MM/YYYY") : "",
  },
  {
    title: "Thời gian BN đến",
    dataIndex: "thoiGianDenPT",
    show: true,
    align: "center",
    width: 150,
    render: (text, record) =>
      text ? moment(text).format("HH:mm DD/MM/YYYY") : "",
  },
  {
    title: "Ngày hẹn PT",
    dataIndex: "ngayHenPT",
    show: true,
    align: "center",
    width: 150,
    render: (text, record) =>
      text ? moment(text).format("HH:mm DD/MM/YYYY") : "",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    align: "center",
    width: 80,
  },
];

const rejectColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    width: 50,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    align: "left",
    width: 70,
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    show: true,
    align: "left",
    width: 170,
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    show: true,
    width: 150,
    align: "right",
    render: (v) => formatPhoneNumber(v),
  },
  // {
  //   title: "Loại BN",
  //   dataIndex: "loaiBN",
  //   show: true,
  //   width: 150,
  //   align: "right",
  // },
  {
    title: "Chỉ định",
    dataIndex: "phieuChiDinhResponseDto",
    show: true,
    width: 500,
    align: "left",
    render: (v) =>
      v?.nhomChiDinhDtos.map((e) => {
        if (e.tenNhomChiDinh === "Phẫu thuật") {
          return e.chiDinhDtos[0].tenChiDinh;
        }
      }),
  },
  {
    title: "Lý do từ chối",
    dataIndex: "lyDoTuChoi",
    show: true,
    align: "left",
    width: 150,
  },
  {
    title: "TG hẹn gọi lại",
    dataIndex: "ngayHenPT",
    show: true,
    align: "center",
    width: 170,
    render: (text, record) =>
      text ? moment(text).format("HH:mm DD/MM/YYYY") : "",
  },
  {
    title: "Trạng thái CSKH",
    dataIndex: "trangThaiCSKH",
    show: true,
    align: "left",
    width: 200,
    render: (text) => {
      return (
        JSON.parse(localStorage.getItem("TTCSKH")).find(
          (option) => option.value === text
        )?.label || ""
      );
    },
  },
];

const backToTheDoctorColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    width: 50,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    align: "center",
    width: 70,
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    show: true,
    align: "left",
    width: 150,
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    show: true,
    width: 150,
    align: "right",
    render: (v) => formatPhoneNumber(v),
  },
  {
    title: "Loại BN",
    dataIndex: "loaiBN",
    show: true,
    width: 150,
    align: "right",
    render: (value, record) => {
      return (
        <>
          <KCBTypeColumn label={value} />
        </>
      );
    },
  },

  {
    title: "TG hoàn thành KCB",
    dataIndex: "ngayHoanThanhKCB",
    show: true,
    width: 150,
    align: "center",
    render: (text, record) => {
      return text ? convertDateStringToDateTimezone_7Dayjs(text) : "";
    },
  },
  {
    title: "TG phẫu thuật",
    dataIndex: "ngayPT",
    show: true,
    align: "center",
    width: 150,
    render: (text, record) => {
      return text ? convertDateStringToDateTimezone_7Dayjs(text) : "";
    },
  },
  {
    title: "TG xuất viện",
    dataIndex: "ngayXuatVien",
    show: true,
    align: "center",
    width: 150,
    render: (text, record) => {
      return text ? convertDateStringToDateTimezone_7Dayjs(text) : "";
    },
  },
  {
    title: "TG hẹn tái khám",
    dataIndex: "ngayHenTK",
    show: true,
    align: "center",
    width: 150,
    render: (text, record) => {
      return text ? convertDateStringToDateTimezone_7Dayjs(text) : "";
    },

    // text ? moment(text).format("HH:mm DD/MM/YYYY") : "",
  },
  {
    title: "Thời gian tái khám",
    dataIndex: "thoiGianTaiKham",
    show: true,
    width: 150,
    align: "center",
    render: (text, record) => {
      let days = null;
      const ngayTaiKham = convertIosStringToDateDayjs(
        formatDateToString(record?.ngayHenTK),
        FORMAT_TIME.dayFull
      );

      const ngayHoanThanhKCB = convertIosStringToDateDayjs(
        formatDateToString(record?.ngayHoanThanhKCB),
        FORMAT_TIME.dayFull
      );
      const ngayXuatVien = convertIosStringToDateDayjs(
        formatDateToString(record?.ngayXuatVien),
        FORMAT_TIME.dayFull
      );

      if (ngayTaiKham) {
        if (ngayXuatVien) {
          days = ngayTaiKham?.diff(ngayXuatVien, "day");
        } else if (ngayHoanThanhKCB) {
          days = ngayTaiKham?.diff(ngayHoanThanhKCB, "day");
        }
      } else {
      }

      return days ? `Tái khám sau ${days} ngày` : "";
    },
  },
  {
    title: "Trạng thái CSKH",
    dataIndex: "trangThaiCSKH",
    show: true,
    align: "left",
    width: 200,
    render: (text) => {
      return (
        JSON.parse(localStorage.getItem("TTCSKH")).find(
          (option) => option.value === text
        )?.label || ""
      );
    },
  },
];
const BdPatientColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    width: 30,
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    align: "center",
    width: 70,
  },
  {
    title: "Tên BN",
    dataIndex: "hoTen",
    show: true,
    align: "left",
    width: 200,
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    show: true,
    width: 100,
    align: "center",
    render: (v) => formatPhoneNumber(v),
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    show: true,
    width: 100,
    align: "center",
    render: (v) =>
      convertDateStringToDateTimezone_7Dayjs(v, FORMAT_TIME.dayFull),
  },
  {
    title: "Tuổi",
    dataIndex: "tuoi",
    show: true,
    width: 50,
    align: "center",
    render: (v) => birthday2Age(v),
  },
  {
    title: "Nguồn BN",
    dataIndex: "nguonBenhNhan",
    show: true,
    width: 100,
    align: "left",
    // render: (v) => JSON(v),
  },
  {
    title: "TG hoàn thành KCB",
    dataIndex: "ngayHoanThanhKCB",
    show: true,
    width: 100,
    align: "center",
    render: (v) => convertDateStringToDateTimezone_7Dayjs(v),
  },
];

const fieldsOfAgree: DataFormField[] = [
  {
    label: "Ngày hẹn PT",
    type: FIELD_TYPE.DATE_DAY_INPUT,
    disabledDate: false,
    disableDate: false,
  },
  {
    label: "Thời gian hẹn gọi lại",
    type: FIELD_TYPE.DATE_DAY_INPUT,
    disabledDate: false,
    disableDate: false,
  },
];

export {
  apoitmentColumns,
  rejectColumns,
  backToTheDoctorColumns,
  fieldsOfAgree,
  fields,
  BdPatientColumns,
};
